/**
 * @ngdoc directives
 * @memberof mercury.modules.cashup
 * @name cashupotherinput
 * @description Input directive to allow setting a money total using individual tender types
 */
angular.module('mercury.modules.cashup.edit')
.directive('cashupotherinput', ["$parse", "$timeout", function($parse, $timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    templateUrl: 'modules/cashup/edit/cashupotherinput.tpl.html',
    link: function(scope, elem, attrs) {
      scope.popoverOpen = false;
      scope.addTenderId = null;

      scope.cashup = $parse(attrs.cashup)(scope);
      scope.totalOther = $parse(attrs.ngModel)(scope);

      scope.addTenderOptions = function() {
        var options = [];
        angular.forEach(scope.cashup.lines, function(tenderline) {
          if (tenderline.systemAmount === 0 && tenderline.countedAmount === 0 && !tenderline.isCash && !tenderline.show) {
            options.push(tenderline);
          }
        });
        return options;
      };

      scope.update = function() {
        $timeout(function() {
          scope.$eval(attrs.ngChange);
        }, 5);
      };

      scope.addTenderSelect = function() {
        angular.forEach(scope.cashup.lines, function(tenderline) {
          if (tenderline.tenderTypeId == scope.addTenderId) {
            tenderline.show = true;
          }
        });

        $timeout(function() {
          scope.addTenderId = null;

          scope.$broadcast('popoverResize');
        });

      };

      scope.close = function() {
        scope.popoverOpen = false;
      };

      scope.$watch(attrs.ngModel, function(value) {
        scope.totalOther = value;
      });
    }
  };
}]);
